import{b as a}from"./chunk-ZRT45YCM.js";var e,c=a((()=>{e={env:{NODE_ENV:"production",npm_package_version:"5.34.0"}}}));export{c as a,e as b};